// apps/platform/src/features/ProblemWorkspace/PaneControls.tsx
// Shared header controls for the workspace panes (desktop only).
import { Maximize2, Minimize2, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PaneMaximizeButton({
  isMaximized,
  onToggle,
  label,
}: {
  isMaximized: boolean;
  onToggle: () => void;
  label: string;
}) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="hidden h-7 w-7 md:flex"
      onClick={onToggle}
      title={isMaximized ? 'Restore layout' : `Maximize ${label}`}
      aria-label={isMaximized ? 'Restore layout' : `Maximize ${label}`}
    >
      {isMaximized ? <Minimize2 className="h-3.5 w-3.5" /> : <Maximize2 className="h-3.5 w-3.5" />}
    </Button>
  );
}

export function PaneCollapseButton({
  isCollapsed,
  onToggle,
}: {
  isCollapsed: boolean;
  onToggle: () => void;
}) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="hidden h-7 w-7 md:flex"
      onClick={onToggle}
      title={isCollapsed ? 'Expand panel' : 'Collapse panel'}
      aria-label={isCollapsed ? 'Expand panel' : 'Collapse panel'}
    >
      {isCollapsed ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
    </Button>
  );
}
